module.exports = __webpack_public_path__ + "img/car-circle-bolt.8e5145c5.svg";